/* @ngInject */
function customerCompanyService ($rootScope, CONSTANTS) {
  const service = {
    getCompanyBaseUrl
  }
  return service

  function getCompanyBaseUrl () {
    let baseSuffix = '.deskfy.io'
    let baseSubdomain = $rootScope.subdomain ? $rootScope.subdomain : 'app'
    const isHTTPS = CONSTANTS.ENVIRONMENT !== 'dev'

    if (CONSTANTS.ENVIRONMENT === 'dev') {
      baseSuffix = 'localhost:9000/#!'
      baseSubdomain = ''
    } else if (CONSTANTS.ENVIRONMENT === 'qa') {
      baseSubdomain = 'qa'
    }

    return isHTTPS ? `https://${baseSubdomain}${baseSuffix}` : `http://${baseSubdomain}${baseSuffix}`
  }
}

export { customerCompanyService }
